import { lazy } from "react";
import { isChunkLoadError } from "./chunkLoadError";

// React.lazy with retries for the route chunk's import. A plain lazy() gives up
// on the first failed fetch, so one dropped request on a store machine, or a
// request that lands mid-deploy, sent the user straight to the error screen
// (support task 41863718, Sentry MY-ROYAL-GENIE-FRONTEND-7F: the login chunk of
// the live build failed on first load).
//
// Only chunk-load failures are retried. Any other error is thrown at once: a
// module that throws while evaluating will throw again.
//
// This cannot fix a stale chunk, whose file no longer exists on the server; the
// retries fail too, and AppErrorFallback's reload picks up the live build.
// That costs the user RETRY_DELAYS_MS in total before the reload, which is
// accepted.
//
// In the Royal Momentum WebView build every dynamic import is inlined
// (vite.config.js `inlineDynamicImports`), so the import cannot fail and this is
// a plain lazy() there.
const RETRY_DELAYS_MS = [500, 1500];

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const lazyWithRetry = (importChunk) =>
    lazy(async () => {
        for (let attempt = 0; ; attempt += 1) {
            try {
                return await importChunk();
            } catch (error) {
                if (attempt >= RETRY_DELAYS_MS.length || !isChunkLoadError(error)) throw error;
                await wait(RETRY_DELAYS_MS[attempt]);
            }
        }
    });
